/**
 * Created by Richard on 04.01.24
 */
export const getRootContext = ($) => {
    const contexts = /** @type {BrickContext[]} */ ([$]);
    for (const current of contexts) {
        const parent = current.getParent();
        parent && contexts.push(parent);
    }
    return contexts.pop();
};
export const getApplicationContext = ($) => {
    const contexts = /** @type {BrickContext[]} */ ([$]);
    for (const current of contexts) {
        const parent = current.getParent();
        parent && contexts.push(parent);
    }
    contexts.pop();
    return contexts.pop();
};
